import React, { Component } from 'react';

class ArticleInstagramPostWidget extends Component {
  constructor(props){
    super(props);  
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { value } = e.target;        
    const object = this.getWidgetObject();        
    object.uri = value;
    this.props.changeObject(this.props.index, object);
  }

  getWidgetObject() {
    return {
      type: 'instagramPost',
      uri: this.props.data.uri,      
      uuid: this.props.data.uuid,
    };
  }

  render() {        
    return (
      <div
        data-index={this.props.index}
        className="panel panel-default widget-body"
      >
        <div className="panel-heading">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={() => this.props.moveWidget(this.props.index, 'up')}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={() => this.props.moveWidget(this.props.index, 'down')}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <span className="panel-title">
            <strong>{this.props.name}</strong>
          </span>
          <a
            onClick={() => this.props.didRemoveWidget(this.props.index)}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body">
          <div className="form-group col-sm-12">
            <input
              onChange={this.handleChange}   
              value={this.props.data.uri}
              className="form-control"
              placeholder="www.instagram.com/..."
              name="widget-instagram-post"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default ArticleInstagramPostWidget;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleInstagramPostWidget.jsx